export const termsAndConditions = [
  {
    sectionNumber: 1,
    sectionHeader: 'DEFINITIONS',
    subText:
      'In these terms and conditions, the terms below have the following meanings:',
    sectionPoints: [
      {
        id: '1.1',
        detail: `<strong>"Old Mutual"</strong> group means Old Mutual Emerging Markets Proprietary Limited,
                     a company incorporated in South Africa, with registration number 1998/012277/07 and with its 
                     registered address at Mutualpark, Jan Smuts Drive, Pinelands, 7405, South Africa, 
                     and includes all its subsidiaries;`,
      },
      {
        id: '1.2',
        detail: `<strong>"Personal Information"</strong> means personal information as referred to in the 
                    Protection of Personal Information Act, 2013;`,
      },
      {
        id: '1.3',
        detail: `<strong>"Processing"</strong> means the automated or manual activity of collecting, recording,
            organising, storing,
            updating, distributing and removing or deleting of Personal Information;`,
      },
      {
        id: '1.4',
        detail: `<strong>"Snapshot"</strong> means the functionality of the Website that provides a brief overview
            containing your personal
            and financial information, personal wishes and instructions as they relate to your will;`,
      },
      {
        id: '1.5',
        detail: `<strong>"Terms and Conditions"</strong> means these terms and conditions, as same may be amended by us
            from time to time by
            publication on this Website;`,
      },
      {
        id: '1.6',
        detail: `<strong>"Website"</strong> means this website at <a class="text-decoration-underline"
            href="${determineFrontEndUrl(
              true
            )}" target="_blank">${determineFrontEndUrl()}</a> owned and managed by us that incorporates the
          online will drafting platform and all content found thereon or services and functionality offered by it;`,
      },
      {
        id: '1.7',
        detail: `<strong>"us"</strong> or <strong>"we"</strong> means Online Wills (Pty) Ltd, a company incorporated in
            South Africa, with registration
            number 2010/011767/07 and with its physical address at Mutualpark, Jan Smuts Drive, Pinelands, 7405. We are a
            subsidiary of the Old Mutual group of companies; and`,
      },
      {
        id: '1.8',
        detail: `<strong>"you"</strong> and <strong>"your"</strong> means the user of the Website.`,
      },
    ],
  },
  {
    sectionNumber: 2,
    sectionHeader: 'GENERAL',
    subText: null,
    sectionPoints: [
      {
        id: '2.1',
        detail: `These Terms and Conditions govern your use of the Website. When you make use of the Website 
            for the first time you will be required to accept these Terms and Conditions. 
            Thereafter, and each time you access the Website, you agree to be bound by the Terms and Conditions 
            as applicable at that time. You may not use, access, display, use, download, and/or otherwise copy or 
            distribute content obtained from the Website.`,
      },
      {
        id: '2.2',
        detail: `The Website is an online will drafting service. Should you however require expert estate planning 
            or financial advice during the process of drafting of your will, we can refer you to a financial adviser. 
            For this service, certain fees and charges may become payable. Remember, the will drafting service remains 
            free and you will, subject to these Terms and Conditions, still be able to draft a will for free. 
            Please refer to clause 5.`,
      },
      {
        id: '2.3',
        detail: `By agreeing to these Terms and Conditions, you consent to the data and Personal Information 
            collected during the will drafting process being shared by us with the Old Mutual group in order for the 
            Old Mutual group to present financial products to you for your consideration. These products may be offered to 
            you by the Old Mutual group or its authorised partners. Please see clause 6 below for a list of these partners.`,
      },
      {
        id: '2.4',
        detail: `These Terms and Conditions must be read together with the privacy notice that applies to how we use your 
            Personal Information as well as the accessing and use of this Website by you. The privacy notice is available <a href="https://www.oldmutual.co.za/privacy-notice/" target="_blank">here</a>.`,
      },
    ],
  },
  {
    sectionNumber: 3,
    sectionHeader: 'SERVICES DETAILS',
    subText: null,
    sectionPoints: [
      {
        id: '3.1',
        detail: `The Website is an online will drafting service. You will be required to provide us with an online Snapshot. This enables us to draft a document that, if signed in the legally 
            correct manner as required in South African law, will constitute a legally valid will.`,
      },
      {
        id: '3.2',
        detail: `As part of the information that you provide to us you can also provide burial request information, details of the legatees and heirs of your estate and appoint legal guardians.`,
      },
      {
        id: '3.3',
        detail: `By using our platform, you are required to nominate Online Wills (Pty) Ltd, Company Registration Number: 2019/162087/07 t/a as Old Mutual Will, as the professional executor to administer your estate. This ensures that your assets will be distributed, your estate will be administered, and your wishes will be executed with the expertise and efficiency of our experienced team.`,
      },
      {
        id: '3.4',
        detail: `As the mandatory executor of your estate, we reserve the right to appoint a suitably qualified service provider to render the services of an executor on our behalf. An executor’s fee (up to a statutory maximum of 3.5% excluding VAT of the value of the estate) may be payable by your estate to Old Mutual Will (or it’s service providers) as the appointed executor.`,
      },
      {
        id: '3.5',
        detail: `You will be provided with a step-by-step guide containing instructions on how to sign your will, together with your witnesses. 
            You understand that the will as provided by us is not a legally valid will unless and until it is signed and witnessed correctly as required by South African law.`,
      },
      {
        id: '3.6',
        detail: `You can access and update your Snapshot at any time.`,
      },
      {
        id: '3.7',
        detail: `You are required to remotely update your Snapshot at least annually to ensure the information remains current. 
            The information is maintained by us until you die. When this happens, we will make the contents of your Snapshot available to the nominated executor.`,
      },
    ],
  },
  {
    sectionNumber: 4,
    sectionHeader: 'ESTATES PLANNING SERVICES',
    subText: null,
    sectionPoints: [
      {
        id: '4.1',
        detail: `You may request to receive estate planning advice. Should you choose to do so, you will be referred 
                to one of our partners described in clause 5 below. They will assist you in obtaining the necessary estate planning advice so 
                that a suitable will can be drafted for you.`,
      },
      {
        id: '4.2',
        detail: `You may be charged a fee for estate planning advice. You will, however, have the right to choose not to receive 
                estate planning advice. Should you decide not to receive estate planning advice, we may continue to provide you with a 
                free will without the benefit of estate planning advice. As a responsible corporate citizen, we will however also have 
                the discretion to refuse to provide you with a free will if, in our opinion, it is not in your best interests to 
                receive a free will without obtaining estate planning advice.`,
      },
    ],
  },
  {
    sectionNumber: 5,
    sectionHeader: 'COMPREHENSIVE FINANCIAL SERVICES ARE AVAILABLE',
    subText: null,
    sectionPoints: [
      {
        id: '5.1',
        detail: `During the will drafting process you will be providing us with information that will enable us to generate your will. 
            In the process of drafting a will, you may realize that you require life cover to protect against estate expenses (like estate duty) 
            or to leave a legacy to your loved ones. You acknowledge that in such an instance a number of parties may become involved in the process 
            of drafting your will and that they may offer you financial products that are suited to your needs and wishes.`,
      },
      {
        id: '5.2',
        detail: `You agree and consent that as a result, we may share your personal information and all other will drafting 
            related information with our partners in accordance with our privacy notice [available <a href="https://www.oldmutual.co.za/privacy-notice/" target="_blank">here</a>].`,
      },
      {
        id: '5.3',
        detail: `We have partnered with the following entities for these purposes:`,
        subSet: [
          {
            id: '5.3.1',
            detail: `Old Mutual Life Assurance Company (South Africa) Ltd;`,
          },
          {
            id: '5.3.2',
            detail: `Old Mutual Alternative Risk Transfer (Pty) Ltd;`,
          },
          {
            id: '5.3.3',
            detail: `Old Mutual Insure Ltd;`,
          },
          {
            id: '5.3.4',
            detail: `Old Mutual Finance (RF) (Pty) Limited; and`,
          },
          {
            id: '5.3.5',
            detail: `Different Life (Pty) Ltd.`,
          },
        ],
      },
      {
        id: '5.4',
        detail: `By accepting these Terms and Conditions, you consent to these partners contacting you regarding their services and products as a 
                    result of the information you provide to us and that they may have of you on record.`,
      },
    ],
  },
  {
    sectionNumber: 6,
    sectionHeader: 'YOUR OBLIGATIONS AS A USER',
    subText: null,
    sectionPoints: [
      {
        id: '6.1',
        detail: `You must be 16 years of age or older to qualify as a user of the Website.`,
      },
      {
        id: '6.2',
        detail: `You agree that we do not accept liability for any damages that you may suffer due to the unauthorised use of our Website 
         where the unauthorised access was due to your failure to keep your login details confidential.`,
      },
      {
        id: '6.3',
        detail: `Your national identity number, login details and any passwords are personal to you. You may not allow anyone else to use these under any circumstances. 
             We are not liable to you or any other person for any harm caused or related to the theft or misappropriation of your identity number, login details or passwords, 
             the disclosure thereof or your authorization of somebody else to use your identity number, login details or passwords.`,
      },
      {
        id: '6.4',
        detail: `You agree to notify us immediately if you become aware of or believe there is or may have been any unauthorized use of (or activity using)
             your identity number, login details or passwords or any other unauthorised activity on our Website causing the need to deactivate your login details due to security concerns.`,
      },
      {
        id: '6.5',
        detail: `By accepting these Terms and Conditions, you expressly give consent to us, our partners and the Old Mutual group that we may Process
             any and all Personal Information posted by you and collected and stored by us on your behalf on the Website in accordance with the privacy
              notice [available <a href="https://www.oldmutual.co.za/privacy-notice/" target="_blank">here</a>]. Under no circumstances shall we, our 
              partners or any of company within the Old Mutual group of companies, their respective partners, officers, directors, employees, subsidiaries, 
              sponsors or agents be held liable for any damages (whether direct or indirect, incidental, special or consequential damages and including without limitation, 
                lost revenues or lost profits) arising from or in connection with the Processing of your Personal Information on our Website or systems whether incurred by you or any other third party.`,
      },
    ],
  },
  {
    sectionNumber: 7,
    sectionHeader: 'LIMITATION OF LIABILITY',
    subText: null,
    sectionPoints: [
      {
        id: '7.1',
        detail: `It remains your responsibility to ensure that the will you draft using our Website and as provided to you for your signature 
            is an accurate reflection of your wishes as testator and that the information and instructions you gave us are properly reflected in your will before signing it. `,
      },
      {
        id: '7.2',
        detail: `It is also your responsibility to review your will regularly and to ensure that your will is updated timeously as and when your personal and family circumstances change.`,
      },
      {
        id: '7.3',
        detail: `You agree that we or any member company of the Old Mutual group will not be liable for any damages that you, your heirs, legatees or 
             dependents might suffer as a result of the will provided to you by us. Under no circumstances will we be liable to you for any damages that you, your heirs, 
             legatees or dependents might suffer as a result of: - `,
        subSet: [
          {
            id: '7.3.1',
            detail: `You breaching any of the terms described in these Terms and Conditions;`,
          },
          {
            id: '7.3.2',
            detail: `you not following our instructions given to you regarding the manner in which the will must be signed by all relevant parties; or`,
          },
          {
            id: '7.3.3',
            detail: `you do not accept our direction to you to receive estate planning advice.`,
          },
        ],
      },
    ],
  },
  {
    sectionNumber: 8,
    sectionHeader: 'RENEWAL/UPDATE OF YOUR SNAPSHOT',
    subText: null,
    sectionPoints: [
      {
        id: '8.1',
        detail: `You should, at least annually, update your Snapshot through our Website.`,
      },
      {
        id: '8.2',
        detail: `You must ensure at all stages that your email address and contact details remain correct and updated.`,
      },
      {
        id: '8.3',
        detail: `As a result of your acceptance of these terms and conditions, you agree that we may: -`,
        subSet: [
          {
            id: '8.3.1',
            detail: `Conduct a 'proof of life' on you for the duration of these terms and conditions; `,
          },
          {
            id: '8.3.2',
            detail: `notify you via email of the necessity to update your Snapshot; and`,
          },
          {
            id: '8.3.3',
            detail: `provide you with a copy of your most recent Snapshot for quick confirmation of details.`,
          },
        ],
      },
    ],
  },
  {
    sectionNumber: 9,
    sectionHeader:
      'INSTRUCTIONS FOR COMPLETION AND SIGNATURE OF YOUR OLD MUTUAL WILL',
    subText: null,
    sectionPoints: [
      {
        id: '9.1',
        detail: `South African law has strict requirements on how a will needs to be signed. It is therefore very important that you complete and sign 
                your will properly and correctly, otherwise it can be contested and set aside by the courts on the grounds of being signed incorrectly. 
                After your will has been emailed to you, you must carefully follow the instructions on how to sign the will.`,
      },
      {
        id: '9.2',
        detail: `Should you be uncertain about any aspect of the will or the instructions on signing it, you must contact us immediately to obtain assistance and guidance.`,
      },
      {
        id: '9.3',
        detail: `We cannot accept liability for any consequences to you or your nominated heirs or legatees if you do not follow our instructions carefully.`,
      },
    ],
  },
  {
    sectionNumber: 10,
    sectionHeader: 'UPDATING YOUR OLD MUTUAL WILL',
    subText: null,
    sectionPoints: [
      {
        id: '10.1',
        detail: `Because your personal circumstances or the size of your estate might change from time to time, it is important to review your will at least yearly or whenever your circumstances change.`,
      },
      {
        id: '10.2',
        detail: `You may access your will on our Website at any time to update or change your will, provided that you again validly sign the amended will as instructed by us.`,
      },
      {
        id: '10.3',
        detail: `You will be reminded every year to consider updating your will.`,
      },
    ],
  },
  {
    sectionNumber: 11,
    sectionHeader: 'RULES OF CONDUCT',
    subText: null,
    sectionPoints: [
      {
        id: '11.1',
        detail: `Your use of our Website is subject to all applicable national laws and regulations and, in some cases, international regulation. You are solely responsible for all activities,
             acts and omissions that occur in, from, through or under your login details and we are not, under any circumstances, liable to any third parties for any activity, act or omission that may occur from, 
             through or under your login details or through your use of our Website. You shall not use, allow, or enable others to use our Website, or knowingly condone use of our Website by others, in any manner 
             that is, attempts to, or is likely to:`,
        subSet: [
          {
            id: '11.1.1',
            detail: `Be libellous, defamatory, indecent, vulgar or obscene, pornographic, sexually explicit or sexually suggestive, racially, culturally, or ethnically offensive, harmful, harassing, 
                    intimidating, threatening, hateful, objectionable, discriminatory, or abusive, or which may or may appear to impersonate anyone else;`,
          },
          {
            id: '11.1.2',
            detail: `affect us adversely or reflect negatively on us or a any of the Old Mutual group of companies, their goodwill, name or reputation or cause duress,
                      distress or discomfort to us or anyone else, or discourage any person, firm or enterprise from using all or any portion, features or functions of our Website, 
                      or from advertising, linking or becoming a supplier to us in connection with our Website;`,
          },
          {
            id: '11.1.3',
            detail: `send or result in the transmission of junk e-mail, chain letters, duplicative or unsolicited messages, surveys, contests, pyramid scheme, or so-called "spamming" and "phishing"; `,
          },
          {
            id: '11.1.4',
            detail: `be used for commercial or business purposes, including, without limitation, advertising, marketing or offering goods or services, whether or not for financial or any other form of compensation or through linking with any other system or website pages;`,
          },
          {
            id: '11.1.5',
            detail: `transmit, distribute or upload programmes or material that contain malicious code, such as viruses, timebombs, cancelbots, worms, trojan horses, spyware, or other potentially harmful programs or other material or information;`,
          },
          {
            id: '11.1.6',
            detail: `create a false identity for the purpose of misleading others;`,
          },
          {
            id: '11.1.7',
            detail: `violate any laws, regulations (including, without limitation, laws regarding the transmission of technical data or software exported from the Republic of South Africa), 
                      judicial or governmental order or any treaties, or violate or infringe upon any intellectual property rights, rights of publicity or privacy or any other of our rights or of any 
                      other person, firm or enterprise; gain unauthorized access to our Website, other users' accounts, names, passwords, personally identifiable information or other computers, websites 
                      or pages, connected or linked to our Website or to use our Website in any manner which violates or is inconsistent with the terms and conditions of these Terms and Conditions;`,
          },
          {
            id: '11.1.8',
            detail: `modify, disrupt, impair, alter or interfere with the use, features, functions, operation or maintenance of our Website or the rights of use and enjoyment of our Website by any other person, firm or enterprise.`,
          },
        ],
      },
      {
        id: '11.2',
        detail: `Should we determine that you have, in our opinion, breached one of the Rules of Conduct set out in above, we reserves the right to remove your access to our Website and prevent you from using our Website.`,
      },
    ],
  },
  {
    sectionNumber: 12,
    sectionHeader: 'UPDATING OF THESE TERMS AND CONDITIONS',
    subText: null,
    sectionPoints: [
      {
        id: null,
        detail: `We reserve the right to change, modify, add to or remove from portions or the whole of these Terms and Conditions from time to time.
                  Changes to these Terms and Conditions will become effective upon such changes being posted to the Website. However, it remains your obligation 
                  to read these Terms and Conditions when logging on to familiarize yourself with any and all changes and updates. Your continued use of this Website 
                  following the posting of changes or updates will be considered notice of your acceptance to abide by and be bound by these Terms and Conditions, 
                  including such changes or updates.`,
      },
    ],
  },
  {
    sectionNumber: 13,
    sectionHeader: 'COPYRIGHT AND INTELLECTUAL PROPERTY RIGHTS',
    subText: null,
    sectionPoints: [
      {
        id: null,
        detail: `This Website contains material which is either owned by us or licensed to us. 
                 This material includes, but is not limited to, the design, layout, look, logos, and graphics. 
                 You are authorized to view and download, print and make copies of such printouts provided that you use the material 
                 for personal and non–commercial purposes only. You may copy the content to individual third parties for their personal use, 
                 but only if you acknowledge this Website as the source of the information and /or materials. 
                 You may not without our expressed written consent distribute or commercially exploit the content.`,
      },
    ],
  },
  {
    sectionNumber: 14,
    sectionHeader: 'SERVICE MAINTENANCE AND AVAILABILITY',
    subText: null,
    sectionPoints: [
      {
        id: '14.1',
        detail: `We rely on the online services of external parties in bringing the Website to you. We reserve the right to suspend the Website at any point if the services provided by the external parties are stopped or interrupted for any reason.`,
      },
      {
        id: '14.2',
        detail: `We may also suspend the Website and restrict access to the entire service or any part thereof, without prior notice to you in order to update or maintain the Website.`,
      },
      {
        id: '14.3',
        detail: `You agree that we will not be liable for any damages that you or your heirs or potential heirs or dependents might suffer as a result of actions in described clauses 14.1 and 14.2.`,
      },
    ],
  },
  {
    sectionNumber: 15,
    sectionHeader: 'SUSPENSION AND/OR TERMINATION OF SERVICES',
    subText: null,
    sectionPoints: [
      {
        id: '15.1',
        detail: `We are entitled, without prejudice to any other rights we may have, to suspend and/or terminate the provision of the Website’s services to you:`,
        subSet: [
          {
            id: '15.1.1',
            detail: `if you are in breach of these Terms and Conditions or the Privacy Notice and/or any other of our policies applicable to your use of the Website;`,
          },
          {
            id: '15.1.2',
            detail: `immediately if we have reason to believe that your use of the Website is fraudulent or negatively impacting the operating capability of the Website;`,
          },
          {
            id: '15.1.3',
            detail: `immediately if we are notified of or suspect unauthorized access or use of your account or have another security concern, to assess and contain the situation;`,
          },
          {
            id: '15.1.4',
            detail: `immediately if we determine, in our sole discretion, that providing the Website or any of its services is prohibited by law;`,
          },
          {
            id: '15.1.5',
            detail: `on 30 (thirty) days written notice to you, if we determine in our sole discretion that it has become impractical or unfeasible for any legal or regulatory reason to continue to provide the Website or any of its services.`,
          },
        ],
      },
    ],
  },
  {
    sectionNumber: 16,
    sectionHeader: 'NOT LIABLE FOR THE EFFECTS OF USE OF OUR WEBSITE',
    subText: null,
    sectionPoints: [
      {
        id: null,
        detail: `Use of the Website, and/or any of the services and products offered through it, is at your sole risk. 
                You shall have no claim against us for any loss, damages, harm, injury, death or expense which may be suffered by 
                you or by any third party from any cause whatsoever, howsoever arising, including, but not limited to any act, 
                omission, default or negligence on our part, failure by us to comply with the Privacy Notice, breach of security or the
                 terms of use by any person including ourselves, your reliance on the content of the online wills drafting system or information or 
                 advice provided to you through the Website, performance of the software, suspension or interruption of your access to this system, or distortion, 
                 corruption or loss of data. Damages shall include direct, indirect, general, special, incidental, punitive and consequential.`,
      },
    ],
  },
  {
    sectionNumber: 17,
    sectionHeader:
      'PERMISSION FOR HYPERLINKS, DEEP LINKING, CRAWLERS AND METATAGS',
    subText: null,
    sectionPoints: [
      {
        id: '17.1',
        detail: `Nobody may establish a hyperlink, frame, metatag or similar reference, whether electronically or otherwise 
                (collectively referred to as linking), to the Website or any subsidiary pages before receiving our prior written approval, 
                which may be withheld or granted subject to the conditions we specify from time to time.`,
      },
      {
        id: '17.2',
        detail: `An application for linking must be submitted to us. Once received we will do our best to respond and enter into further discussions with you. 
                If you don’t get a written response from us within five business days, consider your request as having been rejected.`,
      },
      {
        id: '17.3',
        detail: `Breach of these conditions entitles us to take legal action without prior notice to you and you agree to reimburse the 
                costs associated with such legal action to us on an attorney and own client scale.`,
      },
    ],
  },
  {
    sectionNumber: 18,
    sectionHeader: 'COOKIES',
    subText: null,
    sectionPoints: [
      {
        id: null,
        detail: `"Cookies" are small amounts of information stored by your computer. Our server may issue cookies to your computer so that we can better serve you when you return to our Website. 
                You can set your browser to notify you when you receive a “cookie” giving you the chance to decide whether to accept it. Please see our  <a href="https://www.oldmutual.co.za/cookie-policy/" target="_blank">Cookies Policy</a>.`,
      },
    ],
  },
];

export function determineFrontEndUrl(link) {
  return link ? window.location.origin : window.location.host;
}
